import * as React from 'react';
import Button from '../Button';
import { DeprecatedButtonContainer } from '../ButtonContainer';
import { Form } from '../Form';
import { FormItem } from '../Form/FormItem';
import { ModalTitle } from '../Modal/presenter';
import styles from './style.m.less';

const DELETE_KEYWORD = 'DELETE FOREVER';

const keywordValidator = {
    validate: (keyword: string) => keyword !== DELETE_KEYWORD,
};

interface Props {
    title: string;
    children: React.ReactNode;
    onCancel: () => void;
    onDelete: () => void;
    buttonLabel?: string;
}

interface FormValues {
    keyword: string;
}

export default function DoubleConfirmationDialog({
    title,
    children,
    onCancel,
    onDelete,
    buttonLabel = 'Permanently Delete Now',
}: Props) {
    const initialValues = {
        keyword: __DEV__ ? DELETE_KEYWORD : '',
    };

    return (
        <>
            <ModalTitle>{title}</ModalTitle>
            {children}
            <p>
                Please type "<strong>{DELETE_KEYWORD}</strong>" in the box below to proceed with the deletion.
            </p>
            <Form<FormValues> onSubmit={onDelete} initialValues={initialValues}>
                {({ valid }) => (
                    <div className={styles.confirmbox}>
                        <FormItem
                            name="keyword"
                            label=""
                            validators={[keywordValidator]}
                            inputProps={{
                                placeholder: `Type "${DELETE_KEYWORD}" to proceed`,
                                autoFocus: true,
                                error: null,
                            }}
                        />
                        <DeprecatedButtonContainer>
                            <Button onClick={onCancel}>Cancel</Button>
                            <Button type="submit" kind="WARNING" disabled={!valid}>
                                {buttonLabel}
                            </Button>
                        </DeprecatedButtonContainer>
                    </div>
                )}
            </Form>
        </>
    );
}
